export default __webpack_public_path__ + "static/media/contacts.4f560e2f.png";